import React from "react";
import ArticleCard from "./ArticleCard";

const ArticleList = ({ articles, basePath = "", onArticleClick }) => {
  return (
    <div className="help-article-list-panel">
      {articles.map((article) => (
        <ArticleCard
          key={article.id}
          title={article.title}
          to={basePath ? `${basePath}/${article.id}` : undefined}
          onClick={onArticleClick ? () => onArticleClick(article) : undefined}
        />
      ))}
    </div>
  );
};

export default ArticleList;
